// 7. Сравнение двух свойств
import {createAsyncThunk} from "@reduxjs/toolkit";
import {ComparisonResult, DocumentsState, PropertyFull} from "../../../types";
import {createCacheKey} from "../../../services/utils/helpers";
import {cosineSimilarity} from "../../../services/utils/calculate_matrix";

export const compareTwoPropertiesThunk = createAsyncThunk<
    ComparisonResult,
    { propA: PropertyFull; propB: PropertyFull },
    { state: { documents: DocumentsState }; rejectValue: string }
>(
    'documents/compareTwoProperties',
    async ({ propA, propB }, { getState, rejectWithValue }) => {
        try {
            const cacheKey = createCacheKey(propA, propB);
            const cachedResult = getState().documents.propertiesComparisonCache[cacheKey];
            if (cachedResult !== undefined) {
                return { propA, propB, similarity: cachedResult };
            }

            const intra_similarity = await cosineSimilarity(propA.vectorA, propB.vectorA);
            const inter_similarity = await cosineSimilarity(propA.vectorB, propB.vectorB);
            const similarity: [number, number] = [intra_similarity, inter_similarity];

            return { propA, propB, similarity };
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

// 8. Сравнение свойства с массивом свойств
export const comparePropertyWithProperties = createAsyncThunk<
    ComparisonResult[],
    { propA: PropertyFull; otherProps: PropertyFull[] },
    { state: { documents: DocumentsState }, rejectValue: string }
>(
    'documents/comparePropertyWithProperties',
    async ({ propA, otherProps }, { getState, rejectWithValue }) => {
        try {
            const results: ComparisonResult[] = [];
            for (const propB of otherProps) {
                const cacheKey = createCacheKey(propA, propB);
                let similarity: [number, number] | undefined = getState().documents.propertiesComparisonCache[cacheKey];

                if (similarity === undefined) {
                    const intra_similarity = await cosineSimilarity(propA.vectorA, propB.vectorA);
                    const inter_similarity = await cosineSimilarity(propA.vectorB, propB.vectorB);
                    similarity  = [intra_similarity, inter_similarity];
                }

                if (similarity) {
                    results.push({ propA, propB, similarity });
                }
            }

            return results;
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);


// 9. Сравнение массивов свойств
export const comparePropertiesArrays = createAsyncThunk<
    ComparisonResult[][],
    { propsArrayA: PropertyFull[]; propsArrayB: PropertyFull[] },
    { state: { documents: DocumentsState }; rejectValue: string }
>(
    'documents/comparePropertiesArrays',
    async ({ propsArrayA, propsArrayB }, { getState, rejectWithValue }) => {
        try {
            const results: ComparisonResult[][] = [];

            for (const propA of propsArrayA) {
                const row: ComparisonResult[] = [];
                for (const propB of propsArrayB) {
                    const cacheKey = createCacheKey(propA, propB);
                    let similarity: [number, number] | undefined = getState().documents.propertiesComparisonCache[cacheKey];

                    if (similarity === undefined) {
                        const intra_similarity = await cosineSimilarity(propA.vectorA, propB.vectorA);
                        const inter_similarity = await cosineSimilarity(propA.vectorB, propB.vectorB);
                        similarity = [intra_similarity, inter_similarity];
                    }

                    row.push({ propA, propB, similarity });
                }
                results.push(row);
            }

            return results;
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);